import * as React from "react";

import FormContainer from "../../layout/FormContainer/FormContainer";
import {observer} from "mobx-react";
import {RouteComponentProps} from "react-router-dom";
import {LeadPlanType} from "shared/functions/membersApi/types/ISignupProcess";
import {isMobile} from "react-device-detect";
import WelcomeModalMobile from "./QuickApplicationMobileModal/WelcomeModalMobile";
import NavigationConstants from "../../../Navigation/NavigationConstants";


interface IProps extends RouteComponentProps<any> {}

interface ILocalState {
    isModalVisible: boolean
}

@observer
export default class FormQuickApplication  extends React.Component<
    IProps
    > {

    public state: ILocalState = {
        isModalVisible: true
    };

    public render() {
        return (<>
                {isMobile && this.state.isModalVisible? <WelcomeModalMobile onClose={this.closeModal}/>: null}
                <FormContainer initialPlan = {this.updateQuickApplicationValues()} {...this.props} />
                </>
        );
    }

    private updateQuickApplicationValues = () => {
        const planType = this.props.location.pathname;
        switch (planType) {
            case NavigationConstants.businessLoan: return LeadPlanType.Loan;
            case NavigationConstants.quickRent: return LeadPlanType.Rent;
            default: return undefined;

        }
    }

    private closeModal = () => {
        const newState = this.state;
        newState.isModalVisible = false;
        this.setState(newState);
    }
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/screens/FormQuickApplication/FormQuickApplication.tsx